import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from '../../assets/images/logo.jpg'
import Api from '../../component/Api'
import Loading from "../../component/loader/Loading";
import './Register.css'

// const api = `${Api}/user`;

const Register = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [len, setLen] = useState(1);

    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${Api}/user?email=${email}`)
            .then((res) => res.json())
            .then((req) => {
                setLen(req.length)
            }).catch((err) => {
                toast.error('Failed :' + err.message);
            });
    }, [email])

    const IsValidate = () => {
        let isproceed = true;
        let errormessage = 'Please enter the value in ';
        if (name === null || name === '') {
            isproceed = false;
            errormessage += ' Name ';
        }

        if (password === null || password === '') {
            isproceed = false;
            errormessage += ' Password';
        }
        if (email === null || email === '') {
            isproceed = false;
            errormessage += ' Email';
        }

        if (!isproceed) {
            toast.warning(errormessage)
        } else {
            if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(email)) {

            } else {
                isproceed = false;
                toast.warning('Please enter the valid email')
            }
        }
        return isproceed;
    }


    const handlesubmit = (e) => {
        e.preventDefault();
        console.log(len)
        if (len >= 1) toast.warning(`this email is used.Please Enter other email`)
        let data = { name, password, email };
        // console.log(len)
        if (IsValidate() & len === 0) {
            // console.log(data);
            setIsLoading(true);
            fetch(`${Api}/user`, {
                method: "POST",
                headers: { 'content-type': 'application/json' },
                body: JSON.stringify(data)
            }).then((res) => {
                toast.success('Registered successfully.')
                setIsLoading(false);
                navigate('/login');
            }).catch((err) => {
                toast.error('Failed :' + err.message);
                setIsLoading(false);
            });
        }
    }
    return (
        <div className="container text-center Register" >
            {isLoading ? <Loading /> : " "}
            <div data-aos="zoom-in-down">
                <img className="mb-4 Regimg" src={logo} alt="" width="150px" />
                <form className="row g-3" onSubmit={handlesubmit}>
                    <div className="col-md-6">
                        <label htmlFor="inputEmail4" className="form-label">Email</label>
                        <input type="email" className="form-control" id="inputEmail4" value={email} onChange={e => { setEmail(e.target.value); }} />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="inputPassword4" className="form-label">Password</label>
                        <input type="password" className="form-control" id="inputPassword4" value={password} onChange={e => setPassword(e.target.value)} />
                    </div>
                    <div className="col-12">
                        <label htmlFor="inputName" className="form-label">Name</label>
                        <input type="text" className="form-control" id="inputName" value={name} onChange={e => setName(e.target.value)} />
                    </div>

                    <div className="col-12">
                        <button type="submit" className="btn btn-primary m-2">Register</button>
                        <Link to={'/login'} type="button" className="btn btn-danger">Back</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Register;